import { render, staticRenderFns } from "./nurseTable.vue?vue&type=template&id=45c81599&scoped=true&"
import script from "./nurseTable.vue?vue&type=script&lang=js&"
export * from "./nurseTable.vue?vue&type=script&lang=js&"
import style0 from "./nurseTable.vue?vue&type=style&index=0&id=45c81599&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c81599",
  null
  
)

export default component.exports